// Copyright (c) 2016 Deere & Company

import {
    createErrorObject,
    errorAlertBar
} from '../../../shared/services/alert-bar';
import {translate} from '../../../shared/services/translation-service';

const placeholderMap = {
    CLAIM: 'PART_REQUESTS_SEARCH_BY_CLAIM_PLACEHOLDER',
    DTAC_CASE_NUMBER: 'PART_REQUESTS_SEARCH_BY_DTAC_CASE_NUMBER_PLACEHOLDER',
    PART_NUMBER: 'PART_REQUESTS_SEARCH_BY_PART_NUMBER_PLACEHOLDER',
    PART_REQUEST: 'PART_REQUESTS_SEARCH_BY_PART_REQUEST_PLACEHOLDER',
    PIN: 'PART_REQUESTS_SEARCH_BY_PIN_PLACEHOLDER',
    RGA_WORK_ORDER: 'PART_REQUESTS_SEARCH_BY_WORK_ORDER_PLACEHOLDER'
};

export const getSearchBoxPlaceholder = key =>
    placeholderMap[key];

export const isQueryStringValid = (query, filterType) => {

    if (filterType === 'RGA_WORK_ORDER') {

        return query.length >= 2;

    }

    return query.length >= 4;

};

const errorMap = {
    CLAIM: 'PART_REQUESTS_SEARCH_BY_CLAIM_VALIDATION_ERROR',
    DTAC_CASE_NUMBER: 'PART_REQUESTS_SEARCH_BY_DTAC_CASE_NUMBER_ERROR',
    PART_NUMBER: 'PART_REQUESTS_SEARCH_BY_PART_NUMBER_ERROR',
    PART_REQUEST: 'PART_REQUESTS_SEARCH_BY_PART_REQUEST_ERROR',
    PIN: 'PART_REQUESTS_SEARCH_BY_PIN_ERROR',
    RGA_WORK_ORDER: 'PART_REQUESTS_SEARCH_BY_WORK_ORDER_ERROR'
};

export const getSearchErrorMessageId = key =>
    errorMap[key];

export const sortOptions = [
    {
        displayName: 'DAYS_LEFT',
        path: [
            'daysLeft'
        ]
    },
    {
        displayName: 'PART_REQUEST',
        path: [
            'id'
        ]
    },
    {
        displayName: 'WORK_ORDER',
        path: [
            'reference1'
        ]
    },
    {
        displayName: 'CLAIM',
        path: [
            'claimNumber'
        ]
    },
    {
        displayName: 'PART_NUMBER',
        path: [
            'partNumber'
        ]
    },
    {
        displayName: 'PIN',
        path: [
            'pin'
        ]
    }
];

export const filterOptions = [
    [
        'account',
        'account'
    ],
    [
        'account',
        'name'
    ],
    [
        'account',
        'location',
        'city'
    ],
    ['claimNumber'],
    [
        'firstShipToLocation',
        'name'
    ],
    ['partDescription'],
    ['partNumber'],
    ['pin'],
    ['reference1'],
    ['rgaNumber']
];

const filterRequestTypes = (selectedRequestType, selectedRequestedTypes) =>
    selectedRequestedTypes.some(item => item.key === selectedRequestType);

const filterItemOnDealers = (selectedAccount, selectedDealers) =>
    selectedDealers.some(item => item.account === selectedAccount.account);

const filterItemOnStatuses = (itemToCompare, selectedItems) =>
    selectedItems.length ?
        selectedItems.some(item => item.key === itemToCompare.id) :
        true;

const filterItemOnDateRange = (dateToCheck, selectedDateRange) =>
    selectedDateRange.from <= dateToCheck && dateToCheck <= selectedDateRange.to;

/* eslint-disable max-params */

export const getFilteredSearchResults = (searchResults, selectedDealers, selectedStatuses, selectedDateRange, selectedRequestTypes) =>
    searchResults.filter(item =>
        filterItemOnDealers(item.account, selectedDealers) &&
        filterItemOnStatuses(item.returnStatus, selectedStatuses) &&
        filterItemOnDateRange(item.requestDate, selectedDateRange) &&
        filterRequestTypes(item.requestType.key, selectedRequestTypes)
    );

/* eslint-enable max-params */

export const handleSearch = props => query => {

    const filterType = props.searchByDropdown.selectedOption.key;

    if (isQueryStringValid(query, filterType)) {

        props.actions.updateSearchResults(query);

    } else {

        const translatedErrorMessage = translate(getSearchErrorMessageId(filterType));

        errorAlertBar(createErrorObject(translatedErrorMessage));

    }

};




// WEBPACK FOOTER //
// ./src/part-requests/search/services/helpers.js